import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function RedirectFromExternalHomePage() {
  useEffect(() => {
    window.location.href = `/`;
  }, []);
  return <React.Fragment></React.Fragment>;
}
